import { render, staticRenderFns } from "./TagListPage.vue?vue&type=template&id=c0dccffa&"
import script from "./TagListPage.vue?vue&type=script&lang=ts&"
export * from "./TagListPage.vue?vue&type=script&lang=ts&"
import style0 from "./TagListPage.vue?vue&type=style&index=0&id=c0dccffa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports